<template>
    <b-modal id="send-new-news" size="xlg" title="Create News">
        <b-row>
            <b-col cols="8">
                <div id="add-new-news" class="modal-form">
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Title</h6>
                        </b-col>
                        <b-col>
                            <b-form-group id="newsTitleGroup"
                                          label="News Title"
                                          label-for="newsTitle" class="secondary-label"
                                          :invalid-feedback="errorMessage('title')"
                                          :state="isValid('title')">
                                <b-form-input id="newsTitle"
                                              type="text"
                                              v-model="form.newsTitle"
                                              maxlength="30"
                                              required>
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!--<b-row class="mb-2">-->
                        <!--<b-col>-->
                            <!--<hr class="form-divider">-->
                        <!--</b-col>-->
                    <!--</b-row>-->
                    <!--<b-row no-gutters>-->
                        <!--<b-col sm="12" md="3">-->
                            <!--<h6 class="main-label">Audience</h6>-->
                        <!--</b-col>-->
                        <!--<b-col>-->
                            <!--<b-form-group id="audienceGroup"-->
                                          <!--label="Audience"-->
                                          <!--label-for="audience" class="secondary-label mb-0">-->
                                <!--<b-form-select v-model="form.selectedAudience"-->
                                               <!--:options="form.audienceOptions"-->
                                               <!--class="mb-3 muli-sb" />-->
                            <!--</b-form-group>-->
                        <!--</b-col>-->
                    <!--</b-row>-->
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Image</h6>
                            <span class="label-helper d-inline-block">(350 x 200)</span>
                        </b-col>
                        <b-col>
                            <b-form-group id="news-upload-image" class="secondary-label"
                                          :invalid-feedback="errorMessage('image')"
                                          :state="isValid('image')"
                                          v-b-modal.newsUploadImage>
                            <!--<div id="rewards-upload-image" class="border" v-b-modal.newsUploadImage >-->
                                <!-- Use an if else here for showing an image -->
                                <img v-if="image !== ''" :src="image" alt="Sample Badge">
                                <div class="upload-icon rounded-circle border">
                                </div>
                            <!--</div>-->
                            </b-form-group>
                            <!--<div id="news-upload-image" class="border" v-b-modal.newsUploadImage>-->
                                <!--&lt;!&ndash; Use an if else here for showing an image &ndash;&gt;-->
                                <!--&lt;!&ndash; <img src="../../assets/images/sample-badge.png" alt="Sample Badge"> &ndash;&gt;-->
                                <!--<div class="upload-icon rounded-circle border">-->
                                <!--</div>-->
                            <!--</div>-->
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Details<i id="content-label-help" class="help d-inline-block"></i></h6>
                            <b-popover target="content-label-help"
                                       triggers="hover"
                                       content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
                            </b-popover>
                        </b-col>
                        <b-col>
                            <!--<b-form-group id="subjectGroup"-->
                                          <!--label="Subject"-->
                                          <!--label-for="subject" class="secondary-label">-->
                                <!--<b-form-input id="subject"-->
                                              <!--type="text"-->
                                              <!--v-model="form.subject"-->
                                              <!--required>-->
                                <!--</b-form-input>-->
                            <!--</b-form-group>-->
                            <b-form-group id="messageGroup"
                                          label-for="message" class="secondary-label"
                                          :invalid-feedback="errorMessage('details')"
                                          :state="isValid('details')">
                                <vue-editor id="message" v-model="form.details" required :editorToolbar="customToolbar"></vue-editor>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Publish Date<i id="schedule-label-help" class="help d-inline-block"></i></h6>
                            <b-popover target="schedule-label-help"
                                       triggers="hover"
                                       content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
                            </b-popover>
                        </b-col>
                        <b-col>
                            <b-row no-gutters>
                                <b-col cols="5">
                                    <b-form-group class="mb-1" :invalid-feedback="errorMessage('publish_date')"
                                                  :state="isValid('publish_date')">
                                        <label class="secondary-label align-top">Date</label>
                                        <div class="custom-datepicker mb-3 muli-sb">
                                            <SingleDatepicker :bootstrap-styling="true"
                                                              :value="form.publish"
                                                              ref="publishProgramaticOpen"
                                                              v-model="form.publish"
                                                              wrapper-class="custom-datepicker"
                                                              style="color: #2a2a2a !important;"
                                                              :disabledDates="disabledDates"
                                            >
                                                <div slot="afterDateInput" class="input-group-append pr-0">
                                                                                    <span class="input-group-text">
                                                                                        <img @click="openPublishPicker" src="../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button">
                                                                                    </span>
                                                </div>
                                            </SingleDatepicker>
                                        </div>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <div id="custom-timepicker" style="width: 164px;">
                                        <b-form-group class="ml-3">
                                            <label class="secondary-label align-top">Time</label>
                                            <b-input-group>
                                                <b-input-group-text slot="append">
                                                    <img src="../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                                </b-input-group-text>
                                                <vue-timepicker v-model="publishTime" format="HH:mm:ss" hide-clear-button></vue-timepicker>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Validity<i id="schedule-label-help" class="help d-inline-block"></i></h6>
                            <b-popover target="schedule-label-help"
                                       triggers="hover"
                                       content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
                            </b-popover>
                        </b-col>
                        <b-col>
                            <b-row no-gutters>
                                <b-col cols="5">
                                    <b-form-group class="mb-1" :invalid-feedback="errorMessage('validity')"
                                                  :state="isValid('validity')">
                                        <label class="secondary-label align-top">Date</label>
                                        <div class="custom-datepicker mb-3 muli-sb">
                                            <SingleDatepicker :bootstrap-styling="true"
                                                                  :value="form.validity"
                                                              ref="validityProgramaticOpen"
                                                              v-model="form.validity"
                                                              wrapper-class="custom-datepicker"
                                                              style="color: #2a2a2a !important;"
                                                              :disabledDates="disabledDates"
                                            >
                                                <div slot="afterDateInput" class="input-group-append pr-0">
                                                                                    <span class="input-group-text">
                                                                                        <img @click="openValidityPicker" src="../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button">
                                                                                    </span>
                                                </div>
                                            </SingleDatepicker>
                                        </div>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <div id="custom-timepicker" style="width: 164px;">
                                        <b-form-group class="ml-3">
                                            <label class="secondary-label align-top">Time</label>
                                            <b-input-group>
                                                <b-input-group-text slot="append">
                                                    <img src="../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                                </b-input-group-text>
                                                <vue-timepicker v-model="validityTime" format="HH:mm:ss" hide-clear-button></vue-timepicker>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Button Link</h6>
                        </b-col>
                        <b-col>
                            <div>
                                <switches v-model="form.buttonLinkVisibility"
                                          theme="custom"
                                          color="primary"
                                          type-bold="true"
                                          text-enabled="On"
                                          text-disabled="Off"
                                          style="top: -18px;">
                                </switches>
                                <div style="margin-top: -12px;">
                                    <b-form-group id="buttonTitleGroup"
                                                  label="Button Title"
                                                  label-for="buttonTitle" class="secondary-label"
                                                  :invalid-feedback="errorMessage('button_name')"
                                                  :state="isValid('button_name')">
                                        <b-form-input id="buttonTitle"
                                                      type="text"
                                                      v-model="form.buttonTitle"
                                                      required
                                                      maxlength="20"
                                                      >
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group id="urlLinkGroup"
                                                  label="URL Link"
                                                  label-for="urlLink" class="secondary-label"
                                                  :invalid-feedback="errorMessage('url')"
                                                  :state="isValid('url')">
                                        <b-form-input id="urlLink"
                                                      type="text"
                                                      v-model="form.urlLink"
                                                      required
                                                      maxlength="5000">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Visibility<i id="visibility-label-help" class="help d-inline-block"></i></h6>
                            <b-popover target="visibility-label-help"
                                       triggers="hover"
                                       content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
                            </b-popover>
                        </b-col>
                        <b-col>
                            <div>
                                <span class="d-block mb-3 secondary-label">Publish in App</span>
                                <switches v-model="form.newsVisibility"
                                          theme="custom"
                                          color="primary"
                                          type-bold="true"
                                          text-enabled="On"
                                          text-disabled="Off"
                                          style="top: -18px;" :disabled="form.newsDraft">
                                </switches>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Draft<i id="visibility-label-help" class="help d-inline-block"></i></h6>
                            <b-popover target="visibility-label-help"
                                       triggers="hover"
                                       content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
                            </b-popover>
                        </b-col>
                        <b-col>
                            <div>
                                <span class="d-block mb-3 secondary-label">Draft News</span>
                                <switches v-model="form.newsDraft"
                                          theme="custom"
                                          color="primary"
                                          type-bold="true"
                                          text-enabled="On"
                                          text-disabled="Off"
                                          style="top: -18px;">
                                </switches>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col cols="4">
                <div id="news-mobile-outline" class="mx-auto">
                    <div id="news-mobile-outline-content" class="mx-auto d-block">
                        <div class="banner">
                            <!--<img src="../../assets/images/246x246.png" alt="">-->
                            <img v-if="image === ''" src="../../assets/images/246x246.png" alt="Sample Badge">
                            <img v-else :src="image" alt="Sample Badge">
                        </div>
                        <div class="pt-3 px-2" style="width: 293px; height: 380px; overflow-y: scroll;">
                            <h6 class="news-title">{{ (form.newsTitle == "") ? 'News Title' : form.newsTitle}}</h6>

                            <div v-if="form.details !== ''" v-html="form.details"></div>
                            <div v-else>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                                ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                                reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
                                sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
                                est laborum.
                            </div>

                        </div>
                        <div class="px-2 mx-auto" style="width: 260px; height: 49px;">
                            <b-button variant="primary" block class="news-link">
                                {{ this.form.buttonTitle }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-btn variant="ghost" v-bind:disabled="loading" class="mr-1 btn-cancel" @click="clearFields">
                Cancel
            </b-btn>
            <b-btn variant="primary" v-bind:disabled="loading" class="ml-1" @click="sendForm">
                <template v-if="loading">
                    Saving...
                </template>
                <template v-else>
                    Save
                </template>
            </b-btn>
        </div>
    </b-modal>
</template>

<script>
import { VueEditor, Quill } from "vue2-editor";
import Switches from "vue-switches";
import EngagementNav from "./EngagementNav.vue";
import Datepicker from "vue-bulma-datepicker";
import SingleDatepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import { mapState } from "vuex";
import AddNews from "./AddNews";

function initialState() {
    return {
        form: {
            newsTitle: "",
            // subject: "",
            details: "",
            validity: new Date(),
            publish: new Date(),
            selectedAudience: 1,
            audienceOptions: [
                { value: 1, text: "Segment 1" },
                { value: 2, text: "Segment 2" }
            ],
            newsVisibility: false,
            buttonLinkVisibility: true,
            buttonTitle: "Visit Website",
            urlLink: "http://www.example.com.ph"
        },
        publishTime: {
            HH: "00",
            mm: "00",
            ss: "00"
        },
        validityTime: {
            HH: "00",
            mm: "00",
            ss: "00"
        },
        croppa: {},
        sliderVal: 0,
        sliderMin: 0,
        sliderMax: 0,
        selectedSearchOption: "0",
        searchString: "",
        disabledDates: {
            to: new Date(Date.now() - 8640000)
        },
        customToolbar: [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            ["bold", "italic", "underline"],
            [
                { align: "" },
                { align: "center" },
                { align: "right" },
                { align: "justify" }
            ],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }]
        ]
    };
}
export default {
    name: "news",
    props: ["image"],
    data() {
        return initialState();
    },
    components: {
        EngagementNav,
        Switches,
        Datepicker,
        VueEditor,
        SingleDatepicker,
        VueTimepicker,
        "add-news-tab": AddNews
    },
    computed: {
        ...mapState("news", ["errors", "loading"])
    },
    methods: {
        async sendForm() {
            this.$store.dispatch("news/resetErrors");

            let param = {
                title: this.form.newsTitle,
                details: this.form.details,
                image: this.image.replace(/^data:image\/\w+;base64,/, ""),
                is_draft: this.form.newsDraft,
                sequence: null,
                publish_date: this.formatDate(
                    this.form.publish,
                    this.publishTime
                )
            };

            if (this.form.validity !== undefined) {
                param.validity = this.formatDate(
                    this.form.validity,
                    this.validityTime
                );
            }

            if (this.form.buttonLinkVisibility) {
                param.url = this.form.urlLink;
                param.button_name = this.form.buttonTitle;
            }

            if (!this.form.newsDraft) {
                param.is_enabled = this.form.newsVisibility;
            } else {
                param.is_enabled = false;
            }

            let _this = this;
            await this.$store.dispatch("news/saveNews", param).then(function() {
                if (_this.errors == null) {
                    _this.clearFields();
                    _this.hideModal("send-new-news");
                    _this.getNews(1);
                }
            });
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
        formatDate(date, time) {
            let h = time.HH;
            let m = time.mm;
            let s = time.ss;

            let t = h + ":" + m + ":" + s;

            let d = this.$moment(date).format("YYYY-MM-DD");

            let datetime = d + " " + t;

            return datetime;
        },
        clearFields() {
            let initialData = initialState();

            // Iterate through the props
            for (let prop in initialData) {
                // Reset the prop locally.
                this[prop] = initialData[prop];
            }

            this.hideModal("send-new-news");
            this.$store.dispatch("news/resetErrors");

            this.$emit("clearImage", true);
        },
        async getNews(page) {
            await this.$store.dispatch("news/getNews", page);
        },
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        showModal(modal) {
            this.$root.$emit("bv::show::modal", modal);
        },
        openPublishPicker() {
            this.$refs.publishProgramaticOpen.showCalendar();
        },
        openValidityPicker() {
            this.$refs.validityProgramaticOpen.showCalendar();
        },
        onNewImage() {
            this.sliderVal = this.croppa.scaleRatio;
            this.sliderMin = this.croppa.scaleRatio / 2;
            this.sliderMax = this.croppa.scaleRatio * 2;
        },
        onSliderChange(evt) {
            var increment = evt.target.value;
            this.croppa.scaleRatio = +increment;
        },
        onZoom() {
            this.sliderVal = this.croppa.scaleRatio;
        },
        onSelectPost(record) {
            for (var i = 0; i < this.posts.length; i++) {
                this.posts[i]._rowVariant = "";
            }

            this.posts[record - 1]._rowVariant = "selected";
        }
    }
};
</script>
